import React, { useState } from "react";
import ShotClassContainer from "../ShotClassContainer/ShotClassContainer";
import classes from "./DistributeCollection.module.scss";
import CollectionDeleteModal from "./CollectionDelete/CollectionDeleteModal";
import { setSelectedCollectionDataAction } from "../../../store/actions/actionCreators/distributeActionCreator";
import { useDispatch } from "react-redux";

const DistributeCollectionList = ({
  collectionData,
  setDeleteCollectionData,
  deleteModal,
  setDeleteModal,
  handleCheckboxChange,
}) => {
  const dispatch = useDispatch();
  const [selectedCollectionData, setSelectedCollectionData] = useState(null);

  const handleDelete = (data) => {
    setDeleteModal(true);
    setSelectedCollectionData(data);
    const updatedData = collectionData?.filter((item) => {
      return item?.Collection?.ID !== data?.ID;
    });
    dispatch(setSelectedCollectionDataAction(updatedData));
  };

  return (
    <>
      <div className={classes.distributeCollectionList}>
        {collectionData?.length > 0 &&
          collectionData?.map((item) => (
            <div key={item?.Collection?.ID}>
              <ShotClassContainer
                type="collection"
                data={item?.Collection}
                isInfoIconVisible
                isCheckboxVisible
                infoText={`${
                  item?.Collection?.PublishedbyMe
                    ? "Published by Me "
                    : "Published by Others "
                }`}
                isCopyIconVisible
                isDeleteVisible
                handleDelete={() => handleDelete(item?.Collection)}
                handleCheckboxChange={handleCheckboxChange}
                isChecked={item?.Collection?.checked}
              />
            </div>
          ))}
      </div>
      {deleteModal && (
        <CollectionDeleteModal
          deleteModal={deleteModal}
          setDeleteModal={setDeleteModal}
          selectedCollectionData={selectedCollectionData}
          setDeleteCollectionData={setDeleteCollectionData}
        />
      )}
    </>
  );
};

export default DistributeCollectionList;
